import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { PaymentState } from "./types";
import PaymentService from "@/services/payment.service";
import { AxiosError, AxiosResponse } from "axios";
const service: PaymentService = new PaymentService();

export const actions: ActionTree<PaymentState, RootState> = {
  buy(_, callback: ActionCallback) {
    service
      .buy(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getInvoiceDetail(_, callback: ActionCallback) {
    service
      .getInvoiceDetail(callback?.params.invoice)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
